jQuery(document).ready(function ($) {

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 100) {
      $("body").addClass("sticky");
    } else {
      $("body").removeClass("sticky");
    }
  });

  /* =========================
       Current Year
    ========================= */

  $("#year").text(new Date().getFullYear());

  /* =========================
       Mobile Menu Toggle
    ========================= */
$(document).ready(function () {

  var params = new URLSearchParams(window.location.search);
  var newsletterSuccess = params.get('newsletter_success');


  /* =========================
     FORM 1 SUCCESS
     ========================= */

  if (newsletterSuccess === 'clear') {

    if (!$('#newsletter-home-clear .newsletter-success').length) {

      $('#newsletter-home-clear .newsletter-form').after(
        '<div class="newsletter-success">' +
          '<p>Danke für das Abonnement!</p>' +
        '</div>'
      );

    }
  }


  /* =========================
     FORM 2 SUCCESS
     ========================= */

  if (newsletterSuccess === 'banner') {

    if (!$('#newsletter-home-banner .newsletter-success').length) {

      $('#newsletter-home-banner .newsletter-form').after(
        '<div class="newsletter-success">' +
          '<p>Danke für das Abonnement!</p>' +
        '</div>'
      );

    }
  }


  /* =========================
     FORM 1 SUBMIT
     ========================= */

  $('#newsletter-home-clear').on('submit', function () {

    var $form = $(this);
    var currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set(
      'newsletter_success',
      'clear'
    );

    var $returnTo = $form.find(
      'input[name="return_to"]'
    );

    if (!$returnTo.length) {

      $returnTo = $('<input>', {
        type: 'hidden',
        name: 'return_to'
      });

      $form.append($returnTo);
    }

    $returnTo.val(
      currentUrl.pathname + currentUrl.search
    );

  });


  /* =========================
     FORM 2 SUBMIT
     ========================= */

  $('#newsletter-home-banner').on('submit', function () {

    var $form = $(this);
    var currentUrl = new URL(window.location.href);

    currentUrl.searchParams.set(
      'newsletter_success',
      'banner'
    );

    var $returnTo = $form.find(
      'input[name="return_to"]'
    );

    if (!$returnTo.length) {

      $returnTo = $('<input>', {
        type: 'hidden',
        name: 'return_to'
      });

      $form.append($returnTo);
    }

    $returnTo.val(
      currentUrl.pathname + currentUrl.search
    );

  });

});

});
$(document).ready(function () {
  if (window.location.pathname === '/account/subscribe') {
    $('body').addClass('account-subscribe');
  }
});
$(document).ready(function () {
  if (window.location.pathname === '/account/unsubscribe') {
    $('body').addClass('account-subscribe');
  }
});
